import React from 'react';

import { useSelector } from 'react-redux';

import { ReportCategory } from '~/redux/enums';
import RowSizeSelect from '~/views/components/statsTable/utils/RowSizeSelect';

import { AdvancedButton } from '../buttons';

import LegendButton from '../buttons/legendButton';
import DateRangeSelect from './dateRangeSelect';
import FranchiseSelect from './franchiseSelect';
import GameTypeSelect from './gameTypeSelect';
import PositionSelect from './positionSelect';
import ReportSelect from './reportSelect';

import SeasonRangeSelect from './seasonRangeSelect';
import { FilterContainer, ReportOptionsContainer } from './styles';

const ReportOptions = React.memo(() => {
    const reportCategory = useSelector((state) => state.playersAndTeams.report.reportCategory);
    const timeFrame = useSelector((state) => state.playersAndTeams.report.current.timeFrame);
    return (
        <ReportOptionsContainer>
            {timeFrame === 'season' && <SeasonRangeSelect />}
            {timeFrame === 'game' && <DateRangeSelect />}
            <GameTypeSelect />
            <FranchiseSelect />
            {reportCategory === ReportCategory.Skater && <PositionSelect />}
            <ReportSelect />
            <FilterContainer $reportCategory={reportCategory} $timeFrame={timeFrame}>
                <RowSizeSelect />
                <AdvancedButton />
                <LegendButton />
            </FilterContainer>
        </ReportOptionsContainer>
    );
});

export default ReportOptions;
